import { positionRightAlignedLegend, onPrintLoad, positionBottomLegend } from './legend.onload';
import { preRender } from './legend.prerender';

export { preRender, positionRightAlignedLegend, positionBottomLegend, onPrintLoad };
